import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sentry = defineConnector({
  identifier: "sentry",
  name: "Sentry",
  tagLine: "Error tracking and monitoring",
  keywords: "crash reporting exceptions issues apm traces releases alerts",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://(?:sentry\\.io/.*|[^/]*\\.sentry\\.io/.*)",
  auth: (app) => bearerAuth(app.secret.authToken),
  steps: [
    {
      title: "Get your Sentry auth token",
      items: [
        {
          kind: "markdown",
          content:
            "In Sentry, go to **Settings > Account > API > Auth Tokens** and create a new token with the scopes you need.",
        },
      ],
    },
    {
      title: "Enter your auth token",
      items: [
        {
          kind: "input",
          label: "Auth token",
          required: true,
          target: { kind: "secrets", field: "authToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://sentry.io/api/0/",
  },
});
